import {defineField, defineType} from 'sanity'

import getPageInfo, {seoGroup} from '../objects/pageInfo'
import ProductSkus from '../../components/ProductSkus'

export default defineType({
  name: 'configuration',
  title: 'Configuration',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Configuration Name',
      type: 'string',
      validation: (rule) => rule.required(),
      group: 'content',
    }),
    defineField({
      name: 'fitmentFilter',
      title: 'Limited Fitment Filter',
      type: 'reference',
      to: [{type: 'fitmentFilter'}],
      group: 'content',
    }),
    defineField({
      name: 'configurationAccessories',
      title: 'Accessories Configuration',
      type: 'reference',
      to: [
        {
          type: 'configurationAccessories',
        },
      ],
      group: 'content',
    }),
    defineField({
      name: 'configuration',
      title: 'Configuration',
      description:
        'Filter by either picking a list of filters, or by comma separated list of SKUs. Filters and SKUs are mutually exclusive.',
      type: 'array',
      of: [
        {
          type: 'object',
          fields: [
            // defined at least one field,
            // everything else will be handled from within component
            {name: 'sku', type: 'string'},
          ],
        },
      ],
      components: {
        input: ProductSkus,
      },
      group: 'content',
    }),
    getPageInfo({path: 'configuration'}),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({title = 'New Configuration'}) {
      return {
        title,
        subtitle: 'Configuration',
      }
    },
  },
})
